var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEqualHousingLender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#9D97AB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.8,2L9.2,169.1v60.4h45v207.6H544V229.5h45.8v-58.7L302.8,2z M487.6,384.2H113.9V175.8L302.8,65 l184.8,110.8V384.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "202.3,255.2 202.3,203.9 397.8,203.9 397.8,255.2 202.3,255.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "202.3,280.3 397.8,280.3 397.8,331.5 202.3,331.5 202.3,280.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.1,531h-34.4v65.3h33.5c27,0,42.5-5.8,42.5-31.4C384.8,538.4,367.6,531,343.1,531z M341.4,582.3h-14.7V545 h16.4c11.4,0,22.1,6.6,22.1,19.9C365.1,579.8,355.3,582.3,341.4,582.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.8,569.1c12.3-1.7,18-6.6,18-17.4c0-14.9-7.4-20.7-25.4-20.7H488v65.3h18v-27.3h17.2l18.8,27.3h19.6 L542.8,569.1z M532.1,555.1h-26.2v-9.9h27c7.4,0,10.6,0.8,10.6,5C543.5,555.1,541.1,555.1,532.1,555.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "210.1,531 210.1,596.3 227.3,596.3 227.3,556.6 261.7,596.3 282.1,596.3 282.1,531 264.9,531 264.9,571.5 230.6,531 210.1,531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "41.5,531 41.5,596.3 106.1,596.3 106.1,582.3 59.5,581.5 59.5,531 41.5,531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "124.6,596.3 187.6,596.3 187.6,582.3 143.4,582.3 143.4,568.2 180.2,568.2 180.2,555 143.4,555 143.4,545.1 187.6,545.1 187.6,531 124.6,531 124.6,596.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "404.9,531 404.9,596.3 467.1,595.5 467.1,582.3 422.9,582.3 422.9,568.2 460.5,568.2 460.5,555 422.9,555 422.9,545.1 467.1,545.1 467.1,531 404.9,531  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200,456.2h-13.9l-16.4,58.7h11.9l3.6-13.2H200l3.6,13.2h12.7L200,456.2z M187.8,491.9l4.9-23.2l5.7,23.2 H187.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.5,506.7c2.5-5,3.3-8.3,3.3-15.7v-12.4c0-14.1-3.3-24-19.6-24c-14.7,0-19.6,8.3-19.6,23.2v15.7 c0,19.9,11.4,20.7,45,20.7l0.8-4.1L114.5,506.7z M105.4,493.4c0,10.8-0.8,13.2-7.4,13.2c-5.7,0-7.4-3.3-7.4-14.1v-14.1 c0-10.8,0.8-14.1,8.2-14.1c5.7,0,6.5,1.7,6.5,13.2V493.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.2,499.2c0,9.1,5.7,16.5,18.8,16.5c10.6,0,20.4-7.4,20.4-16.5c0-14.1-26.2-20.7-26.2-29.8 c0-3.3,3.3-5,6.5-5c4.9,0,7.4,3.3,9.8,8.3l8.2-3.3c-0.8-8.3-6.5-14.9-18.8-14.9c-9.8,0-18,5-18,14.9c0,16.5,26.2,20.7,26.2,31.4 c0,4.1-2.5,5.8-7.4,5.8c-4.9,0-8.2-3.3-9.8-9.1L412.2,499.2L412.2,499.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.2,454.5c-12.3,0-19.6,6.6-19.6,22.3v19c0,14.1,4.1,19.9,19.6,19.9c15.5,0,19.6-6.6,19.6-22.3v-18.2 C362.8,460.3,358.7,454.5,343.2,454.5z M350.5,493.4c0,9.9-2.5,13.2-7.4,13.2c-6.5,0-7.4-4.1-7.4-12.4V476c0-7.4,0.8-12.4,7.4-12.4 c6.5,0,7.4,5.8,7.4,12.4V493.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.5,493.4c0,17.4,4.9,22.3,21.3,22.3c12.7,0,16.4-6,16.4-12.4v-19H542v9.1h5.7v6.6c0,5-1.6,7.4-5.7,7.4 c-8.2,0-9-5.8-9-14.1v-13.2c0-9.9,0.8-16.5,9-16.5c5.7,0,9,4.1,9.8,9.9l8.2-3.3c-0.8-9.9-7.4-15.7-18.8-15.7 c-16.4,0-19.6,9.1-19.6,21.5V493.4L521.5,493.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.9,456.2v33.9c0,19.9,3.4,26.2,20.5,26.2c13.1,0,17.9-7.2,17.9-24.5v-35.6h-11.4v33.9 c0,13.2-0.8,16.5-7.4,16.5c-6.5,0-7.4-5-7.4-17.4v-33.1H367.9L367.9,456.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "477.2,456.2 477.2,514.9 487,514.9 487,475.2 500.9,514.9 515.6,514.9 515.6,456.2 505.8,456.2 505.8,492.6 492.7,456.2 477.2,456.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.5,456.2v35.6c0,16.5,1.6,24,18,24c18.8,0,19.6-9.1,19.6-25.6v-33.9h-11.4v34.7c0,11.6-1.6,14.9-7.4,14.9 c-6.5,0-7.4-3.3-7.4-16.5v-33.1H129.5L129.5,456.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "278.3,456.2 278.3,514.9 289.7,514.9 289.7,488.4 303.6,488.4 303.6,514.9 315.1,514.9 315.1,456.2 303.6,456.2 303.6,478.5 289.7,478.5 289.7,456.2 278.3,456.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "40.7,456.2 40.7,514.9 70.1,514.9 70.1,505.8 52.1,505.8 52.1,489.3 68.5,489.3 68.5,481 52.1,481 52.1,465.3 70.1,465.3 70.1,456.2 40.7,456.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "221.5,456.2 221.5,514.9 248.5,514.9 248.5,505.8 231.3,505.8 231.3,456.2 221.5,456.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "457.5,456.2 457.5,514.9 468.1,514.9 468.1,456.2 457.5,456.2  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualHousingLender);
export default __webpack_public_path__ + "static/media/equal-housing-lender.24a0782c4032b8885eb154fc8de4146d.svg";
export { ForwardRef as ReactComponent };